import { HttpParams } from '@angular/common/http';

// Author: https://medium.com/@felipebelluco/httpparams-builder-for-angular-f885aa0a68d2

export class HttpParamsBuilder implements IHttpParamsBuilder {
    private params: HttpParams;

    constructor() {
        this.params = new HttpParams();
    }

    append(param: string, value: any): this {
        if (value) {
            this.params = this.params.append(param, value);
        }
        return this;
    }

    build(): HttpParams {
        return this.params;
    }
}

interface IHttpParamsBuilder {
    append(key: string, value: any): this;
    build(): HttpParams;
}